import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";
import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetCategories_categoryId_Stores_storeId_FixturesPog =
  "/categories/:categoryId/stores/:storeId/fixtures-pog";

export type ParamsGetCategories_categoryId_Stores_storeId_FixturesPog = ExtractRouteParams<
  typeof RouteGetCategories_categoryId_Stores_storeId_FixturesPog
>;

export type ResponseGetCategories_categoryId_Stores_storeId_FixturesPog = PogNonCircular;

export const RoutePostCategories_categoryId_Stores_storeId_FixturesPog =
  RouteGetCategories_categoryId_Stores_storeId_FixturesPog;

export type ParamsPostCategories_categoryId_Stores_storeId_FixturesPog =
  ParamsGetCategories_categoryId_Stores_storeId_FixturesPog;

export type PayloadPostCategories_categoryId_Stores_storeId_FixturesPog = PogNonCircular;
